import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import BogSettingsForm from './BogSettingsForm';
import BetLimitSettingsForm from './BetLimitSettingsForm';
import WidgetSettingsForm from './WidgetSettingsForm';
import CashOutSettingsForm from './CashOutSettingsForm';
import { BetReferralFeature } from './BetReferralFeature/BetReferralFeature';
import { SystemSettingsFormWrapper } from 'src/components/SystemSettingsForm/SystemSettingsForm.style';
import { SystemSettingsSubmenu } from 'src/components/SystemSettingsForm/SystemSettingsSubmenu';
import { AdminSettingsContainer } from 'src/components/SystemSettingsForm/SystemSettingsSubmenu.style';
import { MainContainer } from 'src/domains/layouts/shared/layout/Layout.style';

export const SystemSettingsForm = observer('SystemSettingsForm', (): JSX.Element => {
    const { reduxBackofficeUserState, routerBackoffice } = useAppStateContext();
    const { isSuperUserOrSeniorTrader } = reduxBackofficeUserState;
    const customerParams = routerBackoffice.getParametersString('global', 'tab.tab') ?? 'bog-settings';

    return (
        <SystemSettingsFormWrapper>
            <MainContainer>
                <SystemSettingsSubmenu />

                <AdminSettingsContainer>
                    {customerParams === 'bog-settings' && <BogSettingsForm />}
                    {customerParams === 'bet-limit-settings' && <BetLimitSettingsForm />}
                    {customerParams === 'widget-settings' && <WidgetSettingsForm />}
                    {customerParams === 'cash-out-settings' && <CashOutSettingsForm />}
                    {(customerParams === 'bet-referral-feature' && isSuperUserOrSeniorTrader) && <BetReferralFeature />}
                </AdminSettingsContainer>
            </MainContainer>
        </SystemSettingsFormWrapper>
    );
});
